// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1AwWG","header":"PatientBlock_header__3qxha","label":"PatientBlock_label__4F0Nn","option":"PatientBlock_option__1NVaC"};